import React, { useState, useCallback } from 'react'
import classNames from 'classnames'
import { Button, Dialog, Dialogs } from '@leverege/ui-elements'
import AttributeView from './AttributeView'
import MapAttributeView from './MapAttributeView'
import ArrayAttributeView from './ArrayAttributeView'
import MapGroupAttributeView from './MapGroupAttributeView'
import ArrayGroupAttributeView from './ArrayGroupAttributeView'

import S from './style.css'

export default function GroupAttributeView( props ) {
  const { node, deletable, onSetValue, doSet = true, onDelete, eventData } = props
  const [ opened, setOpened ] = useState( true )

  const onClear = useCallback( ( e ) => {
    const onClose = Dialogs.show( {
      component : Dialog.Question,
      props : {
        title : 'Delete All Fields in Group',
        okay : 'Delete All',
        message : `Are you sure you want to delete ALL fields under "${node.path}"?`,
        onOkay : ( e ) => {    
          if ( doSet ) {
            onSetValue( { attribute : null, path : node.path, value : null } )
          }
          if ( onDelete ) {
            onDelete( { node, data : eventData } )
          }
          onClose()
        }, 
        onCancel : () => { onClose() }
      }
    } )

  }, [ node, onSetValue, onDelete, eventData, doSet ] )

  if ( node.name?.endsWith( '@' ) ) {
    return <MapGroupAttributeView {...props}/>
  }

  if ( node.name?.endsWith( '*' ) ) {
    return <ArrayGroupAttributeView {...props}/>
  }
  const children = node.children || []
  const rows = children.map( ( c ) => {
    let attr = c
    if ( node.path.length > 0 ) {
      let p = c.path
      p = p.substring( p.lastIndexOf( '/' ) + 1 )
      attr = { ...c, path : `${node.path}/${p}` }
    }
    if ( c.type === 'group' ) {
      return <GroupAttributeView {...props} node={attr} key={attr.path} />
    }
    if ( c.path.endsWith( '*' ) ) {
      return <ArrayAttributeView {...props} node={attr} key={attr.path} />
    }
    if ( c.path.endsWith( '@' ) ) {
      return <MapAttributeView {...props} node={attr} key={attr.path} />
    }

    return <AttributeView {...props} node={attr} key={c.path} />
  } )

  const rtn = []
  for ( let i = 0; i < rows.length; i++ ) {
    rtn.push( rows[i] )
    if ( i < rows.length - 1 ) {
      rtn.push( <div key={`div-${i}`} className={S.grpAttrDiv} /> )
    }
  }
  if ( node.name == null ) {
    return (
      <div className={S.grpAttrView}>
        {rtn}
      </div>
    )
  }
  return (
    <div className={S.grpAttrSpanView}>
      <div className={S.attrViewHeader}>
        <div className={S.attrViewLabel}>
          <Button 
            variant="link" 
            style={{ padding : '0px' }}
            icon={opened ? 'fa fa-caret-down fa-fw' : 'fa fa-caret-right fa-fw'} 
            onClick={() => setOpened( !opened )} />
          <span className={S.attrLabel}>{node.name}</span>
          <span className={S.attrArrow}>&rarr;</span>
        </div>
        <div className={S.flexRight}>
          <div className={S.attrViewPath}>{node.path}</div>
          <Button 
            variant="link"
            icon="fa fa-times fa-fw" 
            disabled={deletable === false}
            eventData={node.path}
            onClick={onClear} />
        </div>
      </div>
      { opened && (
        <div className={classNames( S.grpAttrView, S.grpAttrNested )} >
          {rtn}
        </div>
      ) }
    </div>
  )
}
